module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/494de7de0b0bd52c632d519a96b00e24.png";